import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { deletebannerDispatch } from 'reducers/HomeReducer';

export default function TransTable() {
	const { bannerInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const { agent, trans } = useSelector((state) => state.home);
	let newA = [];
	let newB = [];
	if (agent && trans) {
		agent &&
			agent?.result?.map((d) => {
				trans &&
					trans?.result?.map((l) => {
						if (l.agent_id === d.id) {
							newA.push({
								...l,
								agent: d,
							});
						}
					});
			});
	}
	if (newA?.length > 0) {
		newB = newA.sort(function (a, b) {
			return b.id - a.id;
		});
	}
	console.log('first', newA);
	const columns = [
		{ field: 'orderId', headerName: 'OrderId', width: 200 },
		{
			field: 'agent',
			headerName: 'Agent Name',
			width: 200,
			height: 300,
			editable: true,
			renderCell: (params) => (
				<p>{`${params.value.first_name} ${params.value.last_name}`}</p>
			),
		},
		{
			field: 'agent',
			headerName: 'Agency Name',
			width: 200,
			height: 300,
			editable: true,
			renderCell: (params) => <p>{`${params.value.agency_name}`}</p>,
		},
		{
			field: 'type',
			headerName: 'Type',
			width: 200,
		},
		{
			field: 'total_amount',
			headerName: 'Amount(₹)',
			width: 200,
		},
		{
			field: 'markup_amount',
			headerName: 'Markup Amount',
			width: 200,
		},
		{
			field: 'available_amount',
			headerName: 'Available Amount',
			width: 200,
		},
		{
			field: 'item',
			headerName: 'Item',
			width: 200,
		},
		{
			field: 'updated_at',
			headerName: 'Updated On',
			width: 200,
		},
	];
	const handleClick = (event, cellValues) => {
		console.log('id', cellValues.id);
	};
	const handleClickDelete = (event, cellValues) => {
		console.log('id', cellValues.id);
		dispatch(deletebannerDispatch(cellValues.id));
	};
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			{newA && newA?.length > 0 ? (
				<DataGrid
					rows={newA}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 5,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
